export default [
  {
    id: 1,
    name: "Coding",
  },
  {
    id: 2,
    name: "Teaching",
  },
  {
    id: 3,
    name: "Listening to Music",
  },
  {
    id: 4,
    name: "Travelling",
  },
]
